import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import {
  ERAWrapper,
  SubmitClaimsWrapper,
  ClaimStatusWrapper,
  LoginPage,
  ForgotPassword,
  viewOnBoarding,
  LogoutPage,
  settingsPage,
  HomeWrapper,
  InitialRequests,
  EdiConverter
} from "~/app/index";
import "./stylesheets/main.scss";

class App extends Component {
  render() {
    return (
      <div>
        <InitialRequests/>
        <BrowserRouter>
            <Switch>
              {/* <Route exact path="/billing/" component={MTContainer} /> */}
              {/* <Route
                path="/billing/home"
                component={HomeWrapper}
              /> */}
              <Route
                path="/billing/submitclaims"
                component={SubmitClaimsWrapper}
              />
              <Route
                path="/settings"
                component={settingsPage}
              />
              <Route
                path="/logout"
                component={LogoutPage}
              />
              <Route
                path="/viewBoarding"
                component={viewOnBoarding}
              />
              <Route
                path="/login"
                component={LoginPage}
              />
              <Route
                path="/forgotPassword"
              component={ForgotPassword}
              />
              <Route
                path="/billing/claimstatus"
                component={ClaimStatusWrapper}
              />
              <Route
                path="/ediConverter"
              component={EdiConverter}
              />
              <Route path="/billing/era" component={ERAWrapper} />
              <Route
                path="/"
                component={HomeWrapper}
              />
              

              {/* <Route component={SetupOnBoarding} /> */}
              
            </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js